import { PortableText } from "@portabletext/react";
import CodeBlock from "../CodeBlock/CodeBlock";
import CaptionedImage from "../CaptionedImage/CaptionedImage";
import CaptionedVideo from "../CaptionedVideo/CaptionedVideo";

const PortableTextComponent = ({ content }) => {
    const ptComponents = {
        types: {
            imageRow: ({ value }) => {
                const { images } = value;
                if (!images || images.length === 0) {
                    return null;
                }
                return (
                    <div className="image-row" data-count={images.length}>
                        {images.map((image, index) => (
                            <CaptionedImage key={index} image={image} />
                        ))}
                    </div>
                );
            },
            videoRow: ({ value }) => {
                const { videos } = value;
                if (!videos || videos.length === 0) {
                    return null;
                }
                return (
                    <div className="video-row" data-count={videos.length}>
                        {videos.map((video, index) => {
                            return <CaptionedVideo key={index} video={video} />;
                        })}
                    </div>
                );
            },
            code: ({ value }) => {
                const { code, language } = value;
                return <CodeBlock code={code} language={language} />;
            },
        },

        marks: {
            link: ({ children, value }) => {
                const rel = !value.href.startsWith("/") ? "noreferrer noopener" : undefined;
                return (
                    // eslint-disable-next-line react/jsx-no-target-blank
                    <a href={value.href} rel={rel} target="_blank">
                        {children}
                    </a>
                );
            },
            strong: ({ children }) => <strong>{children}</strong>,
            em: ({ children }) => <em>{children}</em>,
        },
    };

    return <PortableText value={content} components={ptComponents} />;
};

export default PortableTextComponent;
